<template>

  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Trends' table</v-toolbar-title>
      <v-divider
          class="mx-2"
          inset
          vertical
      ></v-divider>
      <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="1200px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">New Trend</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :disabled="updateFieldsDisabled" v-model="editedItem.title" label="Trend name, it must be unique across all the trends" :rules="[rules.required, rules.uniqueTitle]"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-select v-model="editedItem.tech_category" :items="categoryTechItems" label="Tech Category" :rules="[rules.required]"></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-select v-model="editedItem.biz_category" :items="categoryBizItems" label="Business Category" :rules="[rules.notEmptyList]" multiple></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <quill-editor
                        ref="myTextEditor"
                        v-model="editedItem.description"
                        :options="editorOption"
                    />

                  </v-flex>

                  <!-- AND CLAUSES - SYNONYMS -->
                  <v-flex xs6 sm6 md6>
                    <v-combobox
                        :disabled="updateFieldsDisabled"
                        ref="andRef"
                        v-model="editedItem.synonyms.and_clauses"
                        label="Insert AND clauses here"
                        chips
                        clearable
                        multiple
                        :rules="[rules.countAndOrClauses]"
                        append-icon
                    >
                      <template v-slot:selection="tag">
                        <v-chip
                            :selected="tag.selected"
                            close
                            dark
                            color="primary"
                            @input="removeSynonyms(tag.item, 'and_clauses')"
                        >
                          <strong>{{ tag.item }}</strong>&nbsp;
                        </v-chip>
                      </template>
                    </v-combobox>
                    <span class="arvix-estimate" :style="{visibility: !updateFieldsDisabled && arxivSourceEstimateAND != null && editedItem.synonyms.and_clauses.length > 0 ? 'visible' : 'hidden'}">
                                            Arxiv document estimates: {{arxivSourceEstimateAND}}
                                          </span>
                  </v-flex>

                  <!-- OR CLAUSES - SYNONYMS -->
                  <v-flex xs6 sm6 md6>
                    <v-combobox
                        :disabled="updateFieldsDisabled"
                        ref="orRef"
                        v-model="editedItem.synonyms.or_clauses"
                        label="Insert OR clauses here"
                        chips
                        clearable
                        multiple
                        :rules="[rules.countAndOrClauses]"
                        append-icon
                    >
                      <template v-slot:selection="tag">
                        <v-chip
                            :selected="tag.selected"
                            close
                            dark
                            color="primary"
                            @input="removeSynonyms(tag.item, 'or_clauses')"
                        >
                          <strong>{{ tag.item }}</strong>&nbsp;
                        </v-chip>
                      </template>
                    </v-combobox>
                    <span class="arvix-estimate" :style=" {visibility: !updateFieldsDisabled && arxivSourceEstimateOR != null && editedItem.synonyms.or_clauses.length > 0 ? 'visible' : 'hidden'}">
                                            Arxiv document estimates: {{arxivSourceEstimateOR}}
                                          </span>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select v-model="editedItem.adoption" :items="adoptionItems" label="Adoption" :rules="[rules.required]"></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select v-model="editedItem.business_relevance" :items="bussrelItems" label="Business Relevance" :rules="[rules.required]"></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select v-model="editedItem.business_impact" :items="bussimpItems" label="Business Impact" :rules="[rules.required]"></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        :items="trends"
        :search="search"
        class="elevation-1"
        :rows-per-page-items='[10,25, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]'

    >
      <template v-slot:items="props">
        <td >{{ props.item.title }}</td>

        <td>{{ props.item.tech_category }}</td>
        <td>
                  <span v-for="category in props.item.biz_category">
                    {{ category }}
                  </span>
        </td>
        <td >{{ props.item.adoption }}</td>
        <td >{{ props.item.business_relevance }}</td>
        <td >{{ props.item.business_impact }}</td>
        <td class="text-xs-right">
          <v-icon
              small
              class="mr-2"
              @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
              small
              @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <p>No Trends Found. Click on NEW TREND button to start saving trends.</p>
      </template>
    </v-data-table>
  </div>

</template>

<script>
import {mapGetters, mapState} from "vuex";
import UrlsService from "@/helpers/UrlsService";
import ApiService from "@/helpers/APIService";
import TimeService from "../../helpers/TimeService";
import NotificationService from "@/helpers/NotificationService";
import {quillEditor,} from "vue-quill-editor"; // component


export default {
  name: "TrendList",
  components: {
    quillEditor
  },
  props: {
    trends: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      dialog: false,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike",],
            /*["blockquote", "code-block",],*/
            /*[{"header": 1,}, {"header": 2,},],*/
            [{"list": "ordered",}, {"list": "bullet",},],
            [{"script": "sub",}, {"script": "super",},],
            [{"indent": "-1",}, {"indent": "+1",},],
            /*[{"direction": "rtl",},],*/
            /*[{"size": ["small", false, "large", "huge",],},],*/
            /*[{"header": [1, 2, 3, 4, 5, 6, false,],},],*/
            /*[{"font": [],},],*/
            [{"color": [],}, {"background": [],},],
            [{"align": [],},],
            ["clean",],
            /*["link", "image", "video",],*/
            ["link",],
          ],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value,
          },
        },
        placeholder: 'Insert here the description...',
        theme: 'snow'
      },
      arxivSourceEstimateAND: null,
      arxivSourceEstimateOR: null,
      search: "",
      progressiveLoaderNum: 0,
      headers: [
        { text: 'Trends Name', value: 'title' },
        { text: 'Tech Category', align: 'left', value: 'tech_category'},
        { text: 'Biz Category', align: 'left', value: 'biz_category'},
        { text: 'Adoption', value: 'adoption' },
        { text: 'Relevance', value: 'business_relevance' },
        { text: 'Impact', value: 'business_impact' },
        { text: 'Actions', value: 'name', sortable: false }
      ],
      categoryTechItems: ["Data & Intelligence", "Intelligent Automation", "Customer Experience", "Internet of Things", "Optimized IT", "Cybersecurity"],
      categoryBizItems: ["Insurance", "Industry", "People & Healthcare","Energy & Utilities", "Telco & Media", "Banking"],
      adoptionItems: ["Adopt", "Try", "Assess"],
      bussrelItems: ["High", "Medium", "Low"],
      bussimpItems: ["Disruptive", "Evolutional"],
      maxOrClauses: 3,
      maxAndClauses: 2,
      maxAndOrClauses: 5,
      updateFieldsDisabled: false,
      rules: {
        required: value => !!value || 'Required.',
        notEmptyList: value => value.length > 0 || 'Required.',
        uniqueTitle: value => !this.titles.includes(value.toLowerCase()) || 'Name not valid. This name already exist.',
        synonyms: value => {
          console.log("rule synonyms: ", value)
          const pattern = /[.,;'àèéìòù]+/gm;
          let bool = false;
          for (let i = 0; i < value.length; i++) {
            if(pattern.test(value[i])){
              bool = true
            }
          }
          return !bool || 'No special characters are allowed';
        },
        uniqueClausesOR: value => {
          let bool = false;
          for (let i = 0; i < value.length; i++) {
            if(this.editedItem.synonyms.or_clauses.includes(value[i].toLowerCase())){
              bool = true
            }
          }
          return !bool || 'Clause not valid. This clause already exists.';
        },
        uniqueClausesAND: value => {
          let bool = false;
          for (let i = 0; i < value.length; i++) {
            if(this.editedItem.synonyms.and_clauses.includes(value[i].toLowerCase())){
              bool = true
            }
          }
          return !bool || 'Clause not valid. This clause already exists.';
        },
        countAndClauses: value => {
          return !(value.length > this.maxAndClauses) || 'Max ' +this.maxAndClauses+' clauses'
        },
        countOrClauses: value => {
          return !(value.length > this.maxOrClauses) || 'Max ' +this.maxOrClauses+' clauses'
        },
        countAndOrClauses: value => {
          return !(this.editedItem.synonyms.and_clauses.length + this.editedItem.synonyms.or_clauses.length > this.maxAndOrClauses) || "Max " +this.maxAndOrClauses+ " combined And-Or clauses"
        }
      },
      editedIndex: -1,
      editedItem: {
        title: "",
        description: "",
        synonyms: {
          "and_clauses": [],
          "or_clauses": []
        },
        adoption: "",
        business_relevance: "",
        business_impact: "",

      },
      defaultItem: {
        title: "",
        description: "",
        synonyms: {"and_clauses":[], "or_clauses": []},
        adoption: "",
        business_relevance: "",
        business_impact: ""
      },
    }
  },
  created() {

  },
  computed: {
    editedSynonyms(){
      return this.editedItem.synonyms;
    },
    ...mapGetters("RadarState", {
          labels: "getTechClassesLabels",
          colors: "getTechClassesColors",
        }
    ),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    titles () {
      if (this.editedIndex > -1) {
        return this.trends.map(x => {
          if(this.trends[this.editedIndex].title.toLowerCase() !== x.title.toLowerCase() ){
            return x.title.toLowerCase()
          }
        })
      } else {
        return this.trends.map(x => x.title.toLowerCase())
      }
    },
    synonyms () {
      let array = [];
      if (this.editedIndex > -1) {
        for(let i=0; i<this.trends.length; i++){
          for(let j=0; j<this.trends[i].synonyms.length; j++){
            if(!this.trends[this.editedIndex].synonyms.includes(this.trends[i].synonyms[j])) array.push(this.trends[i].synonyms[j].toLowerCase())
          }
        }
      } else {
        for(let i=0; i<this.trends.length; i++){
          for(let i=0; i<this.trends.length; i++){
            for(let j=0; j<this.trends[i].synonyms.length; j++){
              array.push(this.trends[i].synonyms[j].toLowerCase())
            }
          }
        }
        //console.log("@@@@ array synonyms", array);
        return array
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    editedSynonyms: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler(){
        this.arxivSourceEstimateAND = null
        this.arxivSourceEstimateOR = null
        this.estimateDocsInTrend()
        this.$refs.andRef.validate()
        this.$refs.orRef.validate()
      }
    }
  },
  methods: {
    initialize () {
      this.trends = this.sources
    },

    editItem (item) {

      this.editedIndex = this.trends.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true
      this.updateFieldsDisabled = true

    },

    deleteItem (item) {
      const index = this.trends.indexOf(item);
      let confirm_prompt = confirm('Are you sure you want to delete this item?')

      if (confirm_prompt){
        let requestUrl = {
          url: UrlsService.deleteTrend,
          timeout: TimeService.secondsToMillis(0),
        };

        let requestObject = {title: item.title};
        console.log(requestObject)
        ApiService.superadmin(requestUrl, requestObject, "post")
            .then ( response => {
              if(response.result){
                this.trends.splice(index, 1)
                this.editedItem = null

                let notificationMessages = {
                  title: "Trend Deletion",
                  loading: "Trend Deletion",
                  success: "Trend deleted correctly",
                };
                let options = {
                  loadingType: "fullscreen",
                  timeout: TimeService.secondsToMillis(0),
                };

                NotificationService.reset()
                let id = this.progressiveLoaderNum.toString(10);
                options = NotificationService.createSuccessNotificationOptions(notificationMessages, options);
                this.progressiveLoaderNum += 1;
                NotificationService.addNotification(id, options);
              }

            } )
            .catch ( error => {
              let notificationMessages = {
                title: "Trend Deletion",
                loading: "Trend Deletion",
                error: "Something went wrong",
              };
              let options = {
                loadingType: "fullscreen",
                timeout: TimeService.secondsToMillis(0),
              };
              this.close()

              NotificationService.reset()
              options = NotificationService.createErrorNotificationOptions(notificationMessages, options);
              let id = this.progressiveLoaderNum.toString(10);
              this.progressiveLoaderNum += 1;
              NotificationService.addNotification(id, options);

            } )
      }

    },

    removeSynonyms(item, clauseType) {
      this.editedItem.synonyms[clauseType].splice(this.editedItem.synonyms[clauseType].indexOf(item), 1);
      this.editedItem.synonyms[clauseType] = [...this.editedItem.synonyms[clauseType],];
    },

    close () {
      this.dialog = false;
      this.updateFieldsDisabled = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if(!this.$refs.form.validate()) {
        return
      }

      if (this.editedIndex > -1) {

        let requestUrl = {
          url: UrlsService.updateTrend,
          timeout: TimeService.secondsToMillis(0),
        };

        ApiService.superadmin(requestUrl, this.editedItem, "post")
            .then ( response => {
              console.log(response)
              if(response.result){
                // update existing trend
                Object.assign(this.trends[this.editedIndex], this.editedItem)
                this.close()

                let notificationMessages = {
                  title: "Trend Update",
                  loading: "Trend Update",
                  success: "Trend updated correctly",
                };
                let options = {
                  loadingType: "fullscreen",
                  timeout: TimeService.secondsToMillis(0),
                  group: "update"
                };

                NotificationService.reset()
                options = NotificationService.createSuccessNotificationOptions(notificationMessages, options);
                let id = (this.progressiveLoaderNum).toString(10);
                let previous_id = (this.progressiveLoaderNum - 1 ).toString(10);
                NotificationService.dismissNotification(previous_id);
                this.progressiveLoaderNum += 1;
                NotificationService.addNotification(id, options);
              }

            } )
            .catch ( error => {

              let notificationMessages = {
                title: "Trend Update",
                loading: "Trend Update",
                error: "Something went wrong",
              };
              let options = {
                loadingType: "fullscreen",
                timeout: TimeService.secondsToMillis(0),
                group: "update"
              };
              this.close()
              NotificationService.reset()
              options = NotificationService.createErrorNotificationOptions(notificationMessages, options);
              let id = this.progressiveLoaderNum.toString(10);
              this.progressiveLoaderNum += 1;
              NotificationService.addNotification(id, options);

            } )

      }else{
        let requestUrl = {
          url: UrlsService.createTrend,
          timeout: TimeService.secondsToMillis(0),
        };
        ApiService.superadmin(requestUrl, this.editedItem, "post")
            .then ( response => {
              console.log(response)
              if(response.result){
                this.trends.push(this.editedItem)
                this.editedItem = this.defaultItem
                this.close()

                let notificationMessages = {
                  title: "Trend Creation",
                  loading: "Trend Creation",
                  success: "Trend created correctly",
                };
                let options = {
                  loadingType: "fullscreen",
                  timeout: TimeService.secondsToMillis(0),
                };

                NotificationService.reset()
                options = NotificationService.createSuccessNotificationOptions(notificationMessages, options);
                let id = this.progressiveLoaderNum.toString(10);
                this.progressiveLoaderNum += 1;
                NotificationService.addNotification(id, options);

              }
            } )
            .catch ( error => {
              this.close()
              let notificationMessages = {
                title: "Trend Creation",
                loading: "Trend Creation",
                error: "Something went wrong",
              };
              let options = {
                loadingType: "fullscreen",
                timeout: TimeService.secondsToMillis(0),
              };

              NotificationService.reset()
              options = NotificationService.createErrorNotificationOptions(notificationMessages, options);
              let id = this.progressiveLoaderNum.toString(10);
              this.progressiveLoaderNum += 1;
              NotificationService.addNotification(id, options);

            } )

      }

    },

    estimateDocsInTrend(){
      let requestUrl = {
        url: UrlsService.estimateDocsTrend,
        timeout: TimeService.secondsToMillis(0),
      };

      let request = {"synonyms": this.editedItem.synonyms}
      ApiService.superadmin(requestUrl, request, "post")
          .then ( response => {
            console.log(response)
            this.arxivSourceEstimateAND = response.results.and_count
            this.arxivSourceEstimateOR = response.results.or_count
          })
          .catch( error => {
            console.log(error)
          })
    }
  }
}
</script>

<style scoped>
.arvix-estimate{
  color: rgba(0,0,0,0.54);
}
</style>
